import {
	HOUSING_ALLOWANCE_WITH_RENT,
	HOUSING_ALLOWANCE_FOR_OWNERS,
	HOUSING_ALLOWANCE_LIMIT,
	HOUSING_ALLOWANCE_LIMIT_PRAGUE,
} from '../LegalParameters/Constants';

export function getDefaultCosts(persons, citySize, contract, year) {
	const index = persons > 4 ? 4 : persons;
	if (contract === 0) {
		return HOUSING_ALLOWANCE_WITH_RENT[year][index][citySize];
	}
	return HOUSING_ALLOWANCE_FOR_OWNERS[year][index][citySize];
}

export function getAllowance(countedCosts, income, cityConst) {
	const allowance = countedCosts - income * cityConst;
	return allowance > 0 ? allowance : 0;
}

export function getCountedCosts(defaultCosts, cost) {
	return Math.min(defaultCosts, cost);
}

export default function({ persons, citySize, contract, cost, income, year }) {
	let cityConst = HOUSING_ALLOWANCE_LIMIT;
	if (citySize === 0) {
		cityConst = HOUSING_ALLOWANCE_LIMIT_PRAGUE;
	}

	const defaultCosts = getDefaultCosts(persons, citySize, contract, year);
	const countedCosts = getCountedCosts(defaultCosts, cost);
	const allowance = getAllowance(countedCosts, income, cityConst);

	return {
		defaultCosts,
		countedCosts,
		allowance,
	};
}
